export default __webpack_public_path__ + "static/ISO-27001-ba0b76f586af63cf1e19cab91f7cee72.png";